var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('page-header'),_c('page-menu'),_c('div',{staticClass:"content-wrapper"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }